import { SharedLinesTypes } from "./index.model";

export const sendInvitationInitiated = (data: any) => ({
  type: SharedLinesTypes.SEND_INVITATION_INITIATED,
  data,
});

export const setInvitationInitiatedResponse = (data: any) => ({
  type: SharedLinesTypes.SET_INVITATION_INITIATED_RESPONSE,
  data,
});

export const setNewInvitationInitiatedResponse = (data: any) => ({
  type: SharedLinesTypes.SET_NEW_INVITATION_INITIATED_RESPONSE,
  data,
});

export const setSharedError = (data: any) => ({
  type: SharedLinesTypes.SET_SHARED_ERROR,
  data,
});

export const updateEmailAlreadyExists = (data: any) => ({
  type: SharedLinesTypes.UPDATE_EMAIL_ALREADY_EXISTS,
  data,
});

export const resetInvitation = (data: any) => ({
  type: SharedLinesTypes.RESET_INVITATION,
  data,
});
export const resetLanguageAndError = () => ({
  type: SharedLinesTypes.RESET_LANGUAGE_ERROR,
});

export const setLongRunningQuery = () => ({
  type: SharedLinesTypes.SET_LONG_RUNNING_QUERY,
});

export const resetToastMessage = () => ({
  type: SharedLinesTypes.RESET_TOAST_MESSAGE,
});
